import React from 'react';
import PropTypes from 'prop-types';
import { Box } from 'core/components';

import SidebarItem from '../SidebarItem';
import CloudMetadata from '../CloudMetadata';

const VirtualCircuitConnectMappings = ({ nodeData, width, popoutTitle, ...rest }) => {
  if (!nodeData) {
    return null;
  }

  const { crossConnectMappings = [] } = nodeData;

  if (crossConnectMappings.length === 0) {
    return null;
  }

  return (
    <Box width={width}>
      {crossConnectMappings.map((crossConnectMapping) => (
        <SidebarItem
          key={crossConnectMapping.id}
          title="Cross Connect Mappings"
          popoutTitle={popoutTitle}
          icon="route"
          dialogProps={{ width: `${width}px` }}
          {...rest}
        >
          <CloudMetadata node={crossConnectMapping} keys={Object.keys(crossConnectMapping)} />
        </SidebarItem>
      ))}
    </Box>
  );
};

VirtualCircuitConnectMappings.propTypes = {
  nodeData: PropTypes.object.isRequired
};

export default VirtualCircuitConnectMappings;
